import api from '@shared/api';
import routes from '@root/routes';
import { PARAMETERS, EVENT_TYPES, EVENTS } from '@root/tracking/constants';
import { TourbookSummary, ListingAnalyticsInformation } from '@root/types';
import { getSourcePageFrom, getListingAnalyticsFromSearchResults } from '@root/tracking/helpers';

type Args = {
  tourbookId: string;
  external: boolean;
  listingId: string;
  onSuccess: (tourbook: TourbookSummary) => void;
};

type RemoveListingInTourbookAction = {
  type: 'LISTING_REMOVED_FROM_TOURBOOK';
  payload: {
    tourbook: TourbookSummary;
    meta: {
      analytics: {
        eventType: 'track';
        event: 'Tourbook Interaction';
        action: 'delete listing';
        sourcePage: string;
        sourceContent: 'tourbook overlay';
        tourbookId: string;
        tourbookName: string;
        tourbookOwnerId: string;
        listingCount: number;
      };
    };
  };
};
export const removeListingFromTourbook = (
  tourbook: TourbookSummary,
  sourcePage: string,
  listingAnalyticsInfo: ListingAnalyticsInformation,
): RemoveListingInTourbookAction => ({
  type: 'LISTING_REMOVED_FROM_TOURBOOK',
  payload: {
    tourbook,
    meta: {
      analytics: {
        eventType: EVENT_TYPES.track,
        event: EVENTS.tourbookInteraction,
        action: PARAMETERS.deleteListing,
        sourcePage,
        sourceContent: PARAMETERS.tourbookOverlay,
        tourbookId: tourbook.id,
        tourbookName: tourbook.name,
        tourbookOwnerId: tourbook.ownerId,
        listingCount: tourbook.listingCount,
        ...listingAnalyticsInfo,
      },
    },
  },
});

export function deleteTourbookListing({
  tourbookId,
  external,
  listingId,
  onSuccess = () => {},
}: Args) {
  return async (dispatch, getState) => {
    const path = external
      ? routes.api.tourbookExternalListing({ tourbookId, externalListingId: listingId })
      : routes.api.tourbookListing({ tourbookId, listingId });
    const response = await api.delete(path);
    const tourbook: TourbookSummary = await response.json();
    const state = getState();
    if (!external) {
      // analytics will fire server side for external delete
      dispatch(
        removeListingFromTourbook(
          tourbook,
          getSourcePageFrom(state)!,
          getListingAnalyticsFromSearchResults(state, listingId),
        ),
      );
    }

    onSuccess(tourbook);
  };
}

export type Actions = RemoveListingInTourbookAction;
